import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from '../api/auth';

const TOKEN_KEY = 'meapulse_token';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const clearSession = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  }, []);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    getMe(token)
      .then(setUser)
      .catch(() => clearSession())
      .finally(() => setLoading(false));
  }, [token, clearSession]);

  const startSession = (accessToken, userInfo) => {
    localStorage.setItem(TOKEN_KEY, accessToken);
    setToken(accessToken);
    setUser(userInfo);
  };

  const logout = () => clearSession();

  const role = user?.role || null;
  const NIVEAUX = ['debutant', 'intermediaire', 'avance'];

  const value = {
    token,
    user,
    loading,
    isAuthenticated: !!user,
    isAdmin: !!user?.is_admin,           // Super Administrateur OU Administrateur
    isSuperAdmin: !!user?.is_super_admin,
    isNiveau: !!role && NIVEAUX.includes(role),
    role,
    roleLabel: user?.role_label || '',
    startSession,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth doit être utilisé à l'intérieur d'un <AuthProvider>");
  }
  return ctx;
};
